var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 203,
    viewBox: "0 0 259 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 166,
    rx: 103.5,
    ry: 27,
    fill: "#E3E3E3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 156,
    rx: 103.5,
    ry: 27,
    fill: "#EEEEEE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 166.5,
    rx: 129.5,
    ry: 36.5,
    fill: "#E3E3E3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 156.5,
    rx: 129.5,
    ry: 36.5,
    fill: "#EEEEEE"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.9,
    cx: 129,
    cy: 152,
    rx: 28,
    ry: 5,
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 77,
    width: 82,
    height: 73,
    fill: "#3C36A8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 123.5,
    width: 107,
    height: 29,
    fill: "white",
    stroke: "#6C63FF",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 138,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 138,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 138,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 139,
    width: 38,
    height: 4,
    rx: 2,
    fill: "#6C63FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 84.5,
    width: 107,
    height: 29,
    fill: "white",
    stroke: "#6C63FF",
    strokeWidth: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 99,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 99,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 99,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 100,
    width: 38,
    height: 4,
    rx: 2,
    fill: "#6C63FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 45.5,
    width: 107,
    height: 29,
    fill: "white",
    stroke: "#6C63FF",
    strokeWidth: 5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 60,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 60,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 60,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EF069A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 61,
    width: 38,
    height: 4,
    rx: 2,
    fill: "#6C63FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 30.5,
    r: 30.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 30.5,
    r: 21.5,
    stroke: "#EF069A",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.062 21L124.333 34.2919L118.937 29.0881L116 31.9321L124.333 40L141 23.8641L138.062 21Z",
    fill: "#EF069A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdq);
export default __webpack_public_path__ + "static/media/IDQ.dadfcfcecb359257dd8e5ece3218ba4a.svg";
export { ForwardRef as ReactComponent };